import { FC, MouseEvent, useCallback, useState } from 'react';

import { ActionIcon } from '@mantine/core';

type ButtonProps = Parameters<typeof ActionIcon<'button'>>[0] & { onClick: (event: MouseEvent) => Promise<void> };

const AsyncActionIcon: FC<ButtonProps> = ({ onClick: passedOnClick, ...props }) => {
    const [isLoading, setIsLoading] = useState(false);

    const onClick = useCallback(
        async (event: MouseEvent) => {
            if (passedOnClick) {
                setIsLoading(true);
                await passedOnClick(event);
                setIsLoading(false);
            }
        },
        [passedOnClick],
    );

    return <ActionIcon onClick={onClick} loading={isLoading} {...props} />;
};

export { AsyncActionIcon };
